export default __webpack_public_path__ + "static/melanie-3abfbb4291ba8c0a4b1a8518310d9fcb.png";